import { computed } from 'vue'

import { usePostHog } from '@/common/composables/usePostHog'

// Feature flag centralization
export function useFeatureFlags() {
  const posthog = usePostHog()

  const isSalesReportsEnabled = computed(() =>
    posthog.isFeatureEnabled('automatic-sales-reporting'),
  )

  const isNewImageCropperApiEnabled = computed(() =>
    posthog.isFeatureEnabled('new_image_cropper_api'),
  )

  const isPerformancePromoteDrawerEnabled = computed(() =>
    posthog.isFeatureEnabled('performance-promote-drawer'),
  )

  const isResidencyPromoteDrawerEnabled = computed(() =>
    posthog.isFeatureEnabled('residency-promote-drawer'),
  )

  const isMarketingAnalyticsEnabled = computed(() =>
    posthog.isFeatureEnabled('marketing-analytics'),
  )

  const isProgressIndicatorVisible = computed(
    () => posthog.getInstance()?.getFeatureFlag('checkout-progress-indicator') === 'bar-visible',
  )

  const isIntercomChatEnabled = computed(() => posthog.isFeatureEnabled('intercom-chat'))

  const isGiftCardRedemptionEnabled = computed(() =>
    posthog.isFeatureEnabled('gift-card-redemption'),
  )

  return {
    isSalesReportsEnabled,
    isNewImageCropperApiEnabled,
    isPerformancePromoteDrawerEnabled,
    isResidencyPromoteDrawerEnabled,
    isMarketingAnalyticsEnabled,
    isProgressIndicatorVisible,
    isIntercomChatEnabled,
    isGiftCardRedemptionEnabled,
  }
}
